"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchContentType = exports.NotificationStatus = exports.ODRModelStatus = exports.ModelsPanelTabType = exports.AppRegion = exports.CutModelAction = exports.SnackbarType = exports.UIAccessModifier = exports.UIRestrictableElement = exports.Pen3DSize = exports.PenSizeIndex = exports.LabelOrientation = exports.LabelType = exports.SortType = exports.ToolType = exports.DeviceKind = exports.Platform = exports.LibraryTab = exports.SupplyTraceSelectedPartType = exports.SupplyTraceType = exports.SupplyTraceSystem = exports.SupplyTraceAction = exports.SubregionType = exports.RegionType = exports.MedicalImageDisplayType = exports.MedicalImageOrientationViewpoint = exports.MedicalImageOrientationPlane = exports.MedicalImageType = exports.PurchaseProgressStage = exports.PopupType = exports.FilterItemType = exports.FilterCategoryType = exports.AccessLevel = exports.NotificationType = exports.AppFeature = exports.LicenseOfferType = exports.LiveModeClassroomState = exports.LicenseType = exports.MembershipStatus = exports.PreferenceBoolOption = exports.Difficulty = exports.GroupID = exports.ContentType = exports.BodyRegionMask = exports.SystemsMenuAction = exports.InfoBoxControl = exports.InfoBoxTabType = exports.ModelType = void 0;
var ModelType;
(function (ModelType) {
    ModelType[ModelType["Undefined"] = -1] = "Undefined";
    ModelType[ModelType["Male"] = 0] = "Male";
    ModelType[ModelType["Female"] = 1] = "Female";
    ModelType[ModelType["BloodVessel"] = 2] = "BloodVessel";
    ModelType[ModelType["BronchialTree"] = 3] = "BronchialTree";
    ModelType[ModelType["LymphoidSystem"] = 4] = "LymphoidSystem";
    ModelType[ModelType["PeripheralNerve"] = 5] = "PeripheralNerve";
    ModelType[ModelType["SkeletalMuscleFiber"] = 6] = "SkeletalMuscleFiber";
    ModelType[ModelType["SkeletalStriatedMuscle"] = 7] = "SkeletalStriatedMuscle";
    ModelType[ModelType["SkeletalSystem"] = 8] = "SkeletalSystem";
    ModelType[ModelType["TheIntegument"] = 9] = "TheIntegument";
    ModelType[ModelType["LowerLegAnimation"] = 10] = "LowerLegAnimation";
    ModelType[ModelType["ForearmAnimation"] = 11] = "ForearmAnimation";
    ModelType[ModelType["ShoulderAnimation"] = 12] = "ShoulderAnimation";
    ModelType[ModelType["NeckAnimation"] = 13] = "NeckAnimation";
    ModelType[ModelType["TorsoAnimation"] = 14] = "TorsoAnimation";
    ModelType[ModelType["ThighAnimation"] = 15] = "ThighAnimation";
    ModelType[ModelType["Eye"] = 16] = "Eye";
    ModelType[ModelType["Tendon"] = 17] = "Tendon";
    ModelType[ModelType["Tooth"] = 18] = "Tooth";
    ModelType[ModelType["Tongue"] = 19] = "Tongue";
    ModelType[ModelType["AdrenalGland"] = 20] = "AdrenalGland";
    ModelType[ModelType["RenalPyramid"] = 21] = "RenalPyramid";
    ModelType[ModelType["OlfactoryBulb"] = 22] = "OlfactoryBulb";
    ModelType[ModelType["Cochlea"] = 23] = "Cochlea";
    ModelType[ModelType["BloodCells"] = 24] = "BloodCells";
    ModelType[ModelType["SecondaryOocyte"] = 25] = "SecondaryOocyte";
    ModelType[ModelType["Sperm"] = 26] = "Sperm";
    ModelType[ModelType["ScalpAndMeninges"] = 27] = "ScalpAndMeninges";
    ModelType[ModelType["PhotoreceptorCells"] = 28] = "PhotoreceptorCells";
    ModelType[ModelType["RetinalLayers"] = 29] = "RetinalLayers";
    ModelType[ModelType["NervousTissueCells"] = 30] = "NervousTissueCells";
    ModelType[ModelType["Synapse"] = 31] = "Synapse";
    ModelType[ModelType["LargeIntestine"] = 32] = "LargeIntestine";
    ModelType[ModelType["HepaticLobule"] = 33] = "HepaticLobule";
    ModelType[ModelType["ClitorisAndPenis"] = 34] = "ClitorisAndPenis";
    ModelType[ModelType["OvarianCycle"] = 35] = "OvarianCycle";
    ModelType[ModelType["EukaryoticCell"] = 36] = "EukaryoticCell";
    ModelType[ModelType["RenalCorpuscle"] = 37] = "RenalCorpuscle";
    ModelType[ModelType["CellMembrane"] = 38] = "CellMembrane";
    ModelType[ModelType["SmallIntestine"] = 39] = "SmallIntestine";
    ModelType[ModelType["Spermatogenesis"] = 40] = "Spermatogenesis";
    ModelType[ModelType["SmoothMuscleTissue"] = 41] = "SmoothMuscleTissue";
    ModelType[ModelType["Pancreas"] = 42] = "Pancreas";
})(ModelType || (exports.ModelType = ModelType = {}));
var InfoBoxTabType;
(function (InfoBoxTabType) {
    InfoBoxTabType[InfoBoxTabType["None"] = 0] = "None";
    InfoBoxTabType[InfoBoxTabType["Description"] = 1] = "Description";
    InfoBoxTabType[InfoBoxTabType["Isolate"] = 2] = "Isolate";
    InfoBoxTabType[InfoBoxTabType["Motion"] = 3] = "Motion";
    InfoBoxTabType[InfoBoxTabType["BoneParts"] = 4] = "BoneParts";
    InfoBoxTabType[InfoBoxTabType["BoneSurfaces"] = 5] = "BoneSurfaces";
    InfoBoxTabType[InfoBoxTabType["MuscleOI"] = 6] = "MuscleOI";
    InfoBoxTabType[InfoBoxTabType["BoneLandmarks"] = 7] = "BoneLandmarks";
    InfoBoxTabType[InfoBoxTabType["MultiSelect"] = 13] = "MultiSelect";
    InfoBoxTabType[InfoBoxTabType["OriginTrace"] = 18] = "OriginTrace";
    InfoBoxTabType[InfoBoxTabType["Innervation"] = 19] = "Innervation";
    InfoBoxTabType[InfoBoxTabType["ArterialSupply"] = 20] = "ArterialSupply";
    InfoBoxTabType[InfoBoxTabType["BranchesTrace"] = 22] = "BranchesTrace";
    InfoBoxTabType[InfoBoxTabType["VideosTreatments"] = 23] = "VideosTreatments";
    InfoBoxTabType[InfoBoxTabType["VideosConditions"] = 24] = "VideosConditions";
    InfoBoxTabType[InfoBoxTabType["VideosExercises"] = 25] = "VideosExercises";
    InfoBoxTabType[InfoBoxTabType["VideosStretches"] = 26] = "VideosStretches";
    InfoBoxTabType[InfoBoxTabType["CrossSections"] = 27] = "CrossSections";
    InfoBoxTabType[InfoBoxTabType["Models"] = 28] = "Models";
    InfoBoxTabType[InfoBoxTabType["DrainageTrace"] = 29] = "DrainageTrace";
    InfoBoxTabType[InfoBoxTabType["TributariesTrace"] = 30] = "TributariesTrace";
    InfoBoxTabType[InfoBoxTabType["Craniometrics"] = 31] = "Craniometrics";
    InfoBoxTabType[InfoBoxTabType["Sutures"] = 32] = "Sutures";
    InfoBoxTabType[InfoBoxTabType["Explode"] = 33] = "Explode";
})(InfoBoxTabType || (exports.InfoBoxTabType = InfoBoxTabType = {}));
var InfoBoxControl;
(function (InfoBoxControl) {
    InfoBoxControl[InfoBoxControl["Isolate"] = 0] = "Isolate";
    InfoBoxControl[InfoBoxControl["Hide"] = 1] = "Hide";
    InfoBoxControl[InfoBoxControl["Fade"] = 2] = "Fade";
    InfoBoxControl[InfoBoxControl["HideOthers"] = 3] = "HideOthers";
    InfoBoxControl[InfoBoxControl["FadeOthers"] = 4] = "FadeOthers";
})(InfoBoxControl || (exports.InfoBoxControl = InfoBoxControl = {}));
var SystemsMenuAction;
(function (SystemsMenuAction) {
    SystemsMenuAction[SystemsMenuAction["Simple"] = 0] = "Simple";
    SystemsMenuAction[SystemsMenuAction["Plus"] = 1] = "Plus";
    SystemsMenuAction[SystemsMenuAction["Minus"] = 2] = "Minus";
    SystemsMenuAction[SystemsMenuAction["LongPlus"] = 3] = "LongPlus";
    SystemsMenuAction[SystemsMenuAction["LongMinus"] = 4] = "LongMinus";
    SystemsMenuAction[SystemsMenuAction["Reset"] = 5] = "Reset";
    SystemsMenuAction[SystemsMenuAction["Slider"] = 6] = "Slider";
})(SystemsMenuAction || (exports.SystemsMenuAction = SystemsMenuAction = {}));
var BodyRegionMask;
(function (BodyRegionMask) {
    BodyRegionMask[BodyRegionMask["Default"] = 0] = "Default";
    BodyRegionMask[BodyRegionMask["Head"] = 1] = "Head";
    BodyRegionMask[BodyRegionMask["Neck"] = 2] = "Neck";
    BodyRegionMask[BodyRegionMask["HeadAndNeck"] = 3] = "HeadAndNeck";
    BodyRegionMask[BodyRegionMask["UpperLimbRight"] = 4] = "UpperLimbRight";
    BodyRegionMask[BodyRegionMask["UpperLimbLeft"] = 8] = "UpperLimbLeft";
    BodyRegionMask[BodyRegionMask["UpperLimb"] = 12] = "UpperLimb";
    BodyRegionMask[BodyRegionMask["Thorax"] = 16] = "Thorax";
    BodyRegionMask[BodyRegionMask["Abdomen"] = 32] = "Abdomen";
    BodyRegionMask[BodyRegionMask["Back"] = 64] = "Back";
    BodyRegionMask[BodyRegionMask["PelvisAndPerineum"] = 128] = "PelvisAndPerineum";
    BodyRegionMask[BodyRegionMask["LowerLimbRight"] = 256] = "LowerLimbRight";
    BodyRegionMask[BodyRegionMask["LowerLimbLeft"] = 512] = "LowerLimbLeft";
    BodyRegionMask[BodyRegionMask["LowerLimb"] = 768] = "LowerLimb";
})(BodyRegionMask || (exports.BodyRegionMask = BodyRegionMask = {}));
var ContentType;
(function (ContentType) {
    ContentType[ContentType["All"] = -100] = "All";
    ContentType[ContentType["Unknown"] = -1] = "Unknown";
    ContentType[ContentType["Screen"] = 0] = "Screen";
    ContentType[ContentType["Recording"] = 1] = "Recording";
    ContentType[ContentType["Question"] = 2] = "Question";
    ContentType[ContentType["Quiz"] = 3] = "Quiz";
    ContentType[ContentType["Video"] = 4] = "Video";
    ContentType[ContentType["Videopack"] = 5] = "Videopack";
    ContentType[ContentType["Lecture"] = 6] = "Lecture";
    ContentType[ContentType["Course"] = 7] = "Course";
    ContentType[ContentType["Model"] = 8] = "Model";
    ContentType[ContentType["Radiology"] = 9] = "Radiology";
    ContentType[ContentType["RadiologyImage"] = 10] = "RadiologyImage";
    ContentType[ContentType["RadiologySequence"] = 11] = "RadiologySequence";
})(ContentType || (exports.ContentType = ContentType = {}));
var GroupID;
(function (GroupID) {
    GroupID[GroupID["All"] = -100] = "All";
    GroupID[GroupID["My"] = 0] = "My";
    GroupID[GroupID["New"] = -1] = "New";
    GroupID[GroupID["Favourites"] = -2] = "Favourites";
    GroupID[GroupID["AddNew"] = -10] = "AddNew";
    GroupID[GroupID["ContentUpdate"] = -5] = "ContentUpdate";
    GroupID[GroupID["Recent"] = -3] = "Recent";
    GroupID[GroupID["Public"] = 4] = "Public";
    GroupID[GroupID["Default"] = 169] = "Default";
    GroupID[GroupID["Atlas"] = -30] = "Atlas";
})(GroupID || (exports.GroupID = GroupID = {}));
var Difficulty;
(function (Difficulty) {
    Difficulty[Difficulty["Beginner"] = 0] = "Beginner";
    Difficulty[Difficulty["Intermediate"] = 1] = "Intermediate";
    Difficulty[Difficulty["Advanced"] = 2] = "Advanced";
})(Difficulty || (exports.Difficulty = Difficulty = {}));
var PreferenceBoolOption;
(function (PreferenceBoolOption) {
    PreferenceBoolOption[PreferenceBoolOption["BeatingHeart"] = 1] = "BeatingHeart";
    PreferenceBoolOption[PreferenceBoolOption["Full3dRotation"] = 2] = "Full3dRotation";
    PreferenceBoolOption[PreferenceBoolOption["DarkTheme"] = 4] = "DarkTheme";
    PreferenceBoolOption[PreferenceBoolOption["ShowHub"] = 8] = "ShowHub";
    PreferenceBoolOption[PreferenceBoolOption["PrivacyNotifications"] = 16] = "PrivacyNotifications";
    PreferenceBoolOption[PreferenceBoolOption["AutoSync"] = 32] = "AutoSync";
    PreferenceBoolOption[PreferenceBoolOption["ShowModelUpdatesIndicators"] = 64] = "ShowModelUpdatesIndicators";
    PreferenceBoolOption[PreferenceBoolOption["ShowTabs"] = 128] = "ShowTabs";
    PreferenceBoolOption[PreferenceBoolOption["ShowTools"] = 256] = "ShowTools";
    PreferenceBoolOption[PreferenceBoolOption["ShowSaveScreenButton"] = 512] = "ShowSaveScreenButton";
    PreferenceBoolOption[PreferenceBoolOption["ShowRecordButton"] = 1024] = "ShowRecordButton";
    PreferenceBoolOption[PreferenceBoolOption["ShowTipsPanel"] = 2048] = "ShowTipsPanel";
    PreferenceBoolOption[PreferenceBoolOption["ShowARPanel"] = 4096] = "ShowARPanel";
    PreferenceBoolOption[PreferenceBoolOption["ShowSafeGuides"] = 8192] = "ShowSafeGuides";
    PreferenceBoolOption[PreferenceBoolOption["ShowExportButton"] = 16384] = "ShowExportButton";
    PreferenceBoolOption[PreferenceBoolOption["NewScreensTooltip"] = 32768] = "NewScreensTooltip";
    PreferenceBoolOption[PreferenceBoolOption["PushNotifications"] = 65536] = "PushNotifications";
})(PreferenceBoolOption || (exports.PreferenceBoolOption = PreferenceBoolOption = {}));
var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus[MembershipStatus["None"] = 0] = "None";
    MembershipStatus[MembershipStatus["Member"] = 1] = "Member";
    MembershipStatus[MembershipStatus["Invited"] = 2] = "Invited";
    MembershipStatus[MembershipStatus["NotMemberByUser"] = 4] = "NotMemberByUser";
    MembershipStatus[MembershipStatus["NotMember"] = 5] = "NotMember";
})(MembershipStatus || (exports.MembershipStatus = MembershipStatus = {}));
var LicenseType;
(function (LicenseType) {
    LicenseType[LicenseType["StudentPlus"] = 0] = "StudentPlus";
    LicenseType[LicenseType["Edu"] = 1] = "Edu";
    LicenseType[LicenseType["Institutional"] = 2] = "Institutional";
    LicenseType[LicenseType["Pro"] = 3] = "Pro";
    LicenseType[LicenseType["Individual"] = 4] = "Individual";
    LicenseType[LicenseType["School"] = 5] = "School";
    LicenseType[LicenseType["Courses"] = 6] = "Courses";
    LicenseType[LicenseType["ExportSnapshot"] = 7] = "ExportSnapshot";
    LicenseType[LicenseType["VideoDownload"] = 8] = "VideoDownload";
    LicenseType[LicenseType["VideoCapture"] = 9] = "VideoCapture";
    LicenseType[LicenseType["CourseBuilder"] = 10] = "CourseBuilder";
    LicenseType[LicenseType["LinkBuilder"] = 11] = "LinkBuilder";
    LicenseType[LicenseType["SurfaceHub"] = 12] = "SurfaceHub";
    LicenseType[LicenseType["TrialManual"] = 13] = "TrialManual";
    LicenseType[LicenseType["TrialRegistration"] = 14] = "TrialRegistration";
    LicenseType[LicenseType["TrialQuizReward"] = 15] = "TrialQuizReward";
    LicenseType[LicenseType["TrialDrChrono"] = 16] = "TrialDrChrono";
    LicenseType[LicenseType["TrialSpecialType1"] = 17] = "TrialSpecialType1";
    LicenseType[LicenseType["TrialSpecialType2"] = 18] = "TrialSpecialType2";
    LicenseType[LicenseType["TrialSpecialType3"] = 19] = "TrialSpecialType3";
    LicenseType[LicenseType["VideoUpload"] = 20] = "VideoUpload";
})(LicenseType || (exports.LicenseType = LicenseType = {}));
var LiveModeClassroomState;
(function (LiveModeClassroomState) {
    LiveModeClassroomState[LiveModeClassroomState["Idle"] = 0] = "Idle";
    LiveModeClassroomState[LiveModeClassroomState["StartHosting"] = 1] = "StartHosting";
    LiveModeClassroomState[LiveModeClassroomState["Hosting"] = 2] = "Hosting";
    LiveModeClassroomState[LiveModeClassroomState["StartJoining"] = 3] = "StartJoining";
    LiveModeClassroomState[LiveModeClassroomState["Joined"] = 4] = "Joined";
})(LiveModeClassroomState || (exports.LiveModeClassroomState = LiveModeClassroomState = {}));
var LicenseOfferType;
(function (LicenseOfferType) {
    LicenseOfferType[LicenseOfferType["Introductory"] = 0] = "Introductory";
    LicenseOfferType[LicenseOfferType["Retaining"] = 1] = "Retaining";
})(LicenseOfferType || (exports.LicenseOfferType = LicenseOfferType = {}));
var AppFeature;
(function (AppFeature) {
    AppFeature[AppFeature["Redeem"] = 0] = "Redeem";
    AppFeature[AppFeature["UpdatePopup"] = 1] = "UpdatePopup";
})(AppFeature || (exports.AppFeature = AppFeature = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["JoinRequest"] = 1] = "JoinRequest";
    NotificationType[NotificationType["Join"] = 2] = "Join";
    NotificationType[NotificationType["Leave"] = 3] = "Leave";
    NotificationType[NotificationType["UserAccept"] = 4] = "UserAccept";
    NotificationType[NotificationType["UserReject"] = 5] = "UserReject";
    NotificationType[NotificationType["AdminAccept"] = 6] = "AdminAccept";
    NotificationType[NotificationType["AdminReject"] = 7] = "AdminReject";
    NotificationType[NotificationType["Invite"] = 8] = "Invite";
    NotificationType[NotificationType["Kick"] = 9] = "Kick";
    NotificationType[NotificationType["Sync"] = 10] = "Sync";
    NotificationType[NotificationType["SyncComplete"] = 11] = "SyncComplete";
    NotificationType[NotificationType["Custom"] = 12] = "Custom";
    NotificationType[NotificationType["UserAdminAccept"] = 13] = "UserAdminAccept";
    NotificationType[NotificationType["UserAdminReject"] = 14] = "UserAdminReject";
    NotificationType[NotificationType["Trial"] = 16] = "Trial";
    NotificationType[NotificationType["Action"] = 18] = "Action";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
var AccessLevel;
(function (AccessLevel) {
    AccessLevel[AccessLevel["None"] = 0] = "None";
    AccessLevel[AccessLevel["Registered"] = 1] = "Registered";
    AccessLevel[AccessLevel["Upgraded"] = 2] = "Upgraded";
    AccessLevel[AccessLevel["Subscribed"] = 3] = "Subscribed";
})(AccessLevel || (exports.AccessLevel = AccessLevel = {}));
var FilterCategoryType;
(function (FilterCategoryType) {
    FilterCategoryType[FilterCategoryType["Master"] = 0] = "Master";
    FilterCategoryType[FilterCategoryType["Course"] = 1] = "Course";
    FilterCategoryType[FilterCategoryType["ResourceType"] = 2] = "ResourceType";
    FilterCategoryType[FilterCategoryType["ResourceGroup"] = 3] = "ResourceGroup";
    FilterCategoryType[FilterCategoryType["ResourceRegion"] = 4] = "ResourceRegion";
    FilterCategoryType[FilterCategoryType["Model"] = 5] = "Model";
    FilterCategoryType[FilterCategoryType["VideoGroups"] = 6] = "VideoGroups";
    FilterCategoryType[FilterCategoryType["VideoTags"] = 7] = "VideoTags";
    FilterCategoryType[FilterCategoryType["VideoCategories"] = 8] = "VideoCategories";
    FilterCategoryType[FilterCategoryType["VideoTypes"] = 9] = "VideoTypes";
    FilterCategoryType[FilterCategoryType["LectureBuilderType"] = 10] = "LectureBuilderType";
    FilterCategoryType[FilterCategoryType["LectureBuilderGroup"] = 11] = "LectureBuilderGroup";
    FilterCategoryType[FilterCategoryType["LectureBuilderRegion"] = 12] = "LectureBuilderRegion";
    FilterCategoryType[FilterCategoryType["RadiologyImageType"] = 13] = "RadiologyImageType";
    FilterCategoryType[FilterCategoryType["RadiologyRegions"] = 14] = "RadiologyRegions";
    FilterCategoryType[FilterCategoryType["RadiologyPlane"] = 15] = "RadiologyPlane";
    FilterCategoryType[FilterCategoryType["RadiologyDisplay"] = 16] = "RadiologyDisplay";
})(FilterCategoryType || (exports.FilterCategoryType = FilterCategoryType = {}));
var FilterItemType;
(function (FilterItemType) {
    FilterItemType[FilterItemType["Main"] = 0] = "Main";
    FilterItemType[FilterItemType["Radio"] = 1] = "Radio";
    FilterItemType[FilterItemType["Check"] = 2] = "Check";
    FilterItemType[FilterItemType["Section"] = 3] = "Section";
    FilterItemType[FilterItemType["Master"] = 4] = "Master";
})(FilterItemType || (exports.FilterItemType = FilterItemType = {}));
var PopupType;
(function (PopupType) {
    PopupType[PopupType["PurchaseProgressOverlay"] = 0] = "PurchaseProgressOverlay";
    PopupType[PopupType["PurchaseFinishedPopup"] = 1] = "PurchaseFinishedPopup";
    PopupType[PopupType["LicenseExpiredPopup"] = 2] = "LicenseExpiredPopup";
    PopupType[PopupType["OfferLinkInvalidPopup"] = 3] = "OfferLinkInvalidPopup";
    PopupType[PopupType["OfferLinkUnavailablePopup"] = 4] = "OfferLinkUnavailablePopup";
    PopupType[PopupType["SubscriptionOfferBuyPopup"] = 5] = "SubscriptionOfferBuyPopup";
    PopupType[PopupType["TrialEndedPopup"] = 7] = "TrialEndedPopup";
    PopupType[PopupType["AfterExpiryRestartPopup"] = 8] = "AfterExpiryRestartPopup";
    PopupType[PopupType["CompletePurchasePopup"] = 9] = "CompletePurchasePopup";
    PopupType[PopupType["SubscriptionOfferOSUpdateRequiredPopup"] = 10] = "SubscriptionOfferOSUpdateRequiredPopup";
    PopupType[PopupType["GenericErrorPopup"] = 11] = "GenericErrorPopup";
})(PopupType || (exports.PopupType = PopupType = {}));
var PurchaseProgressStage;
(function (PurchaseProgressStage) {
    PurchaseProgressStage[PurchaseProgressStage["OfferSigning"] = 0] = "OfferSigning";
    PurchaseProgressStage[PurchaseProgressStage["RequestingToStore"] = 1] = "RequestingToStore";
    PurchaseProgressStage[PurchaseProgressStage["RegisteringWithBackend"] = 2] = "RegisteringWithBackend";
})(PurchaseProgressStage || (exports.PurchaseProgressStage = PurchaseProgressStage = {}));
var MedicalImageType;
(function (MedicalImageType) {
    MedicalImageType[MedicalImageType["All"] = -1] = "All";
    MedicalImageType[MedicalImageType["Unknown"] = 0] = "Unknown";
    MedicalImageType[MedicalImageType["CT"] = 1] = "CT";
    MedicalImageType[MedicalImageType["MRI"] = 2] = "MRI";
    MedicalImageType[MedicalImageType["XRay"] = 3] = "XRay";
    MedicalImageType[MedicalImageType["Angiogram"] = 4] = "Angiogram";
    MedicalImageType[MedicalImageType["Mammogram"] = 5] = "Mammogram";
})(MedicalImageType || (exports.MedicalImageType = MedicalImageType = {}));
var MedicalImageOrientationPlane;
(function (MedicalImageOrientationPlane) {
    MedicalImageOrientationPlane[MedicalImageOrientationPlane["All"] = -1] = "All";
    MedicalImageOrientationPlane[MedicalImageOrientationPlane["Unknown"] = 0] = "Unknown";
    MedicalImageOrientationPlane[MedicalImageOrientationPlane["Axial"] = 1] = "Axial";
    MedicalImageOrientationPlane[MedicalImageOrientationPlane["Coronal"] = 2] = "Coronal";
    MedicalImageOrientationPlane[MedicalImageOrientationPlane["Sagittal"] = 3] = "Sagittal";
})(MedicalImageOrientationPlane || (exports.MedicalImageOrientationPlane = MedicalImageOrientationPlane = {}));
var MedicalImageOrientationViewpoint;
(function (MedicalImageOrientationViewpoint) {
    MedicalImageOrientationViewpoint[MedicalImageOrientationViewpoint["All"] = -1] = "All";
    MedicalImageOrientationViewpoint[MedicalImageOrientationViewpoint["Unknown"] = 0] = "Unknown";
    MedicalImageOrientationViewpoint[MedicalImageOrientationViewpoint["Anterior"] = 1] = "Anterior";
    MedicalImageOrientationViewpoint[MedicalImageOrientationViewpoint["Posterior"] = 2] = "Posterior";
    MedicalImageOrientationViewpoint[MedicalImageOrientationViewpoint["Superior"] = 3] = "Superior";
    MedicalImageOrientationViewpoint[MedicalImageOrientationViewpoint["Inferior"] = 4] = "Inferior";
    MedicalImageOrientationViewpoint[MedicalImageOrientationViewpoint["Caudal"] = 5] = "Caudal";
    MedicalImageOrientationViewpoint[MedicalImageOrientationViewpoint["Cranial"] = 6] = "Cranial";
    MedicalImageOrientationViewpoint[MedicalImageOrientationViewpoint["Lateral"] = 7] = "Lateral";
    MedicalImageOrientationViewpoint[MedicalImageOrientationViewpoint["Medial"] = 8] = "Medial";
    MedicalImageOrientationViewpoint[MedicalImageOrientationViewpoint["Dorsal"] = 9] = "Dorsal";
    MedicalImageOrientationViewpoint[MedicalImageOrientationViewpoint["Ventral"] = 10] = "Ventral";
    MedicalImageOrientationViewpoint[MedicalImageOrientationViewpoint["Superficial"] = 11] = "Superficial";
    MedicalImageOrientationViewpoint[MedicalImageOrientationViewpoint["Deep"] = 12] = "Deep";
})(MedicalImageOrientationViewpoint || (exports.MedicalImageOrientationViewpoint = MedicalImageOrientationViewpoint = {}));
var MedicalImageDisplayType;
(function (MedicalImageDisplayType) {
    MedicalImageDisplayType[MedicalImageDisplayType["SequencesSingleImages"] = 0] = "SequencesSingleImages";
    MedicalImageDisplayType[MedicalImageDisplayType["Sequences"] = 1] = "Sequences";
    MedicalImageDisplayType[MedicalImageDisplayType["AllImages"] = 2] = "AllImages";
})(MedicalImageDisplayType || (exports.MedicalImageDisplayType = MedicalImageDisplayType = {}));
var RegionType;
(function (RegionType) {
    RegionType[RegionType["Unknown"] = 0] = "Unknown";
    RegionType[RegionType["HeadAndNeck"] = 1] = "HeadAndNeck";
    RegionType[RegionType["Thorax"] = 2] = "Thorax";
    RegionType[RegionType["Back"] = 3] = "Back";
    RegionType[RegionType["UpperLimb"] = 4] = "UpperLimb";
})(RegionType || (exports.RegionType = RegionType = {}));
var SubregionType;
(function (SubregionType) {
    SubregionType[SubregionType["Neuroanatomy"] = 1] = "Neuroanatomy";
    SubregionType[SubregionType["Skull"] = 2] = "Skull";
    SubregionType[SubregionType["NasalCavity"] = 3] = "NasalCavity";
    SubregionType[SubregionType["Ear"] = 4] = "Ear";
    SubregionType[SubregionType["Teeth"] = 5] = "Teeth";
    SubregionType[SubregionType["OralCavity"] = 6] = "OralCavity";
    SubregionType[SubregionType["Pharynx"] = 7] = "Pharynx";
    SubregionType[SubregionType["Larynx"] = 8] = "Larynx";
    SubregionType[SubregionType["ThoracicWall"] = 2001] = "ThoracicWall";
    SubregionType[SubregionType["Mediastinum"] = 2002] = "Mediastinum";
    SubregionType[SubregionType["PleuralCavity"] = 2003] = "PleuralCavity";
    SubregionType[SubregionType["Diaphragm"] = 2004] = "Diaphragm";
    SubregionType[SubregionType["VertebralColumn"] = 3001] = "VertebralColumn";
    SubregionType[SubregionType["CervicalSpine"] = 3002] = "CervicalSpine";
    SubregionType[SubregionType["ThoracicSpine"] = 3003] = "ThoracicSpine";
    SubregionType[SubregionType["LumbarSpine"] = 3004] = "LumbarSpine";
    SubregionType[SubregionType["PectoralGirdle"] = 4001] = "PectoralGirdle";
    SubregionType[SubregionType["Shoulder"] = 4002] = "Shoulder";
    SubregionType[SubregionType["Arm"] = 4003] = "Arm";
    SubregionType[SubregionType["Elbow"] = 4004] = "Elbow";
    SubregionType[SubregionType["Forearm"] = 4005] = "Forearm";
    SubregionType[SubregionType["Wrist"] = 4006] = "Wrist";
    SubregionType[SubregionType["Hand"] = 4007] = "Hand";
})(SubregionType || (exports.SubregionType = SubregionType = {}));
var SupplyTraceAction;
(function (SupplyTraceAction) {
    SupplyTraceAction[SupplyTraceAction["None"] = 0] = "None";
    SupplyTraceAction[SupplyTraceAction["Highlight"] = 1] = "Highlight";
    SupplyTraceAction[SupplyTraceAction["Default"] = 2] = "Default";
    SupplyTraceAction[SupplyTraceAction["Isolate"] = 3] = "Isolate";
})(SupplyTraceAction || (exports.SupplyTraceAction = SupplyTraceAction = {}));
var SupplyTraceSystem;
(function (SupplyTraceSystem) {
    SupplyTraceSystem[SupplyTraceSystem["Nerves"] = 0] = "Nerves";
    SupplyTraceSystem[SupplyTraceSystem["Arteries"] = 1] = "Arteries";
    SupplyTraceSystem[SupplyTraceSystem["Veins"] = 2] = "Veins";
})(SupplyTraceSystem || (exports.SupplyTraceSystem = SupplyTraceSystem = {}));
var SupplyTraceType;
(function (SupplyTraceType) {
    SupplyTraceType[SupplyTraceType["None"] = 0] = "None";
    SupplyTraceType[SupplyTraceType["Branches"] = 1] = "Branches";
    SupplyTraceType[SupplyTraceType["Origin"] = 2] = "Origin";
})(SupplyTraceType || (exports.SupplyTraceType = SupplyTraceType = {}));
var SupplyTraceSelectedPartType;
(function (SupplyTraceSelectedPartType) {
    SupplyTraceSelectedPartType[SupplyTraceSelectedPartType["None"] = 0] = "None";
    SupplyTraceSelectedPartType[SupplyTraceSelectedPartType["HeartPart"] = 1] = "HeartPart";
    SupplyTraceSelectedPartType[SupplyTraceSelectedPartType["SkeletalPart"] = 2] = "SkeletalPart";
    SupplyTraceSelectedPartType[SupplyTraceSelectedPartType["InnervationPart"] = 3] = "InnervationPart";
    SupplyTraceSelectedPartType[SupplyTraceSelectedPartType["Nerve"] = 4] = "Nerve";
    SupplyTraceSelectedPartType[SupplyTraceSelectedPartType["Vein"] = 5] = "Vein";
    SupplyTraceSelectedPartType[SupplyTraceSelectedPartType["Artery"] = 6] = "Artery";
})(SupplyTraceSelectedPartType || (exports.SupplyTraceSelectedPartType = SupplyTraceSelectedPartType = {}));
var LibraryTab;
(function (LibraryTab) {
    LibraryTab[LibraryTab["Courses"] = 0] = "Courses";
    LibraryTab[LibraryTab["Atlas"] = 1] = "Atlas";
    LibraryTab[LibraryTab["Models"] = 2] = "Models";
    LibraryTab[LibraryTab["Videos"] = 3] = "Videos";
    LibraryTab[LibraryTab["Radiology"] = 4] = "Radiology";
})(LibraryTab || (exports.LibraryTab = LibraryTab = {}));
var Platform;
(function (Platform) {
    Platform[Platform["Mac"] = 1] = "Mac";
    Platform[Platform["iPhone"] = 2] = "iPhone";
    Platform[Platform["iPad"] = 4] = "iPad";
    Platform[Platform["iOS"] = 6] = "iOS";
    Platform[Platform["Apple"] = 7] = "Apple";
    Platform[Platform["Windows"] = 8] = "Windows";
    Platform[Platform["SurfaceHub"] = 16] = "SurfaceHub";
    Platform[Platform["Microsoft"] = 24] = "Microsoft";
    Platform[Platform["Android"] = 32] = "Android";
    Platform[Platform["Chromebook"] = 64] = "Chromebook";
    Platform[Platform["Google"] = 96] = "Google";
})(Platform || (exports.Platform = Platform = {}));
var DeviceKind;
(function (DeviceKind) {
    DeviceKind[DeviceKind["Phone"] = 0] = "Phone";
    DeviceKind[DeviceKind["Tablet"] = 1] = "Tablet";
    DeviceKind[DeviceKind["Desktop"] = 2] = "Desktop";
})(DeviceKind || (exports.DeviceKind = DeviceKind = {}));
var ToolType;
(function (ToolType) {
    ToolType[ToolType["None"] = 0] = "None";
    ToolType[ToolType["Move"] = 1] = "Move";
    ToolType[ToolType["Growth"] = 3] = "Growth";
    ToolType[ToolType["Eraser"] = 7] = "Eraser";
    ToolType[ToolType["Uundo"] = 8] = "Uundo";
    ToolType[ToolType["Redo"] = 9] = "Redo";
    ToolType[ToolType["Spurs"] = 4] = "Spurs";
    ToolType[ToolType["SpursSingle"] = 11] = "SpursSingle";
    ToolType[ToolType["SpursCluster"] = 12] = "SpursCluster";
    ToolType[ToolType["Pain"] = 6] = "Pain";
    ToolType[ToolType["PainSphere"] = 13] = "PainSphere";
    ToolType[ToolType["PainBrush"] = 14] = "PainBrush";
    ToolType[ToolType["Cut"] = 18] = "Cut";
    ToolType[ToolType["SingleCutLayer"] = 19] = "SingleCutLayer";
    ToolType[ToolType["MultiCutLayer"] = 20] = "MultiCutLayer";
    ToolType[ToolType["Cut1Side"] = 22] = "Cut1Side";
    ToolType[ToolType["CutBetween"] = 23] = "CutBetween";
    ToolType[ToolType["CutHole"] = 24] = "CutHole";
    ToolType[ToolType["Text"] = 25] = "Text";
    ToolType[ToolType["Pen"] = 2] = "Pen";
    ToolType[ToolType["Pen2D"] = 28] = "Pen2D";
    ToolType[ToolType["Pen3D"] = 29] = "Pen3D";
    ToolType[ToolType["Sticky"] = 31] = "Sticky";
    ToolType[ToolType["StickyText"] = 32] = "StickyText";
    ToolType[ToolType["StickyImage"] = 33] = "StickyImage";
    ToolType[ToolType["StickyHandWriting"] = 34] = "StickyHandWriting";
    ToolType[ToolType["StickyPhoto"] = 35] = "StickyPhoto";
    ToolType[ToolType["StickyVideo"] = 38] = "StickyVideo";
    ToolType[ToolType["MagicMarker"] = 36] = "MagicMarker";
    ToolType[ToolType["Labels"] = 50] = "Labels";
    ToolType[ToolType["LabelsLeft"] = 51] = "LabelsLeft";
    ToolType[ToolType["LabelsRight"] = 52] = "LabelsRight";
    ToolType[ToolType["Fracture"] = 17] = "Fracture";
    ToolType[ToolType["FractureSimple"] = 26] = "FractureSimple";
    ToolType[ToolType["FractureComminuted"] = 27] = "FractureComminuted";
    ToolType[ToolType["ClearAll"] = 10] = "ClearAll";
    ToolType[ToolType["ClearTool"] = 30] = "ClearTool";
    ToolType[ToolType["ClearSketch"] = 37] = "ClearSketch";
})(ToolType || (exports.ToolType = ToolType = {}));
var SortType;
(function (SortType) {
    SortType[SortType["A_Z"] = 0] = "A_Z";
    SortType[SortType["Z_A"] = 1] = "Z_A";
    SortType[SortType["Recent"] = 2] = "Recent";
    SortType[SortType["MostPopular"] = 3] = "MostPopular";
    SortType[SortType["HighestRated"] = 4] = "HighestRated";
})(SortType || (exports.SortType = SortType = {}));
var LabelType;
(function (LabelType) {
    LabelType[LabelType["Default"] = 0] = "Default";
    LabelType[LabelType["Custom"] = 1] = "Custom";
    LabelType[LabelType["Group"] = 2] = "Group";
})(LabelType || (exports.LabelType = LabelType = {}));
var LabelOrientation;
(function (LabelOrientation) {
    LabelOrientation[LabelOrientation["Custom"] = 0] = "Custom";
    LabelOrientation[LabelOrientation["Left"] = 1] = "Left";
    LabelOrientation[LabelOrientation["Right"] = 2] = "Right";
    LabelOrientation[LabelOrientation["Undefined"] = 3] = "Undefined";
})(LabelOrientation || (exports.LabelOrientation = LabelOrientation = {}));
var PenSizeIndex;
(function (PenSizeIndex) {
    PenSizeIndex[PenSizeIndex["Small"] = 1] = "Small";
    PenSizeIndex[PenSizeIndex["Medium"] = 2] = "Medium";
    PenSizeIndex[PenSizeIndex["Large"] = 3] = "Large";
    PenSizeIndex[PenSizeIndex["XLarge"] = 4] = "XLarge";
})(PenSizeIndex || (exports.PenSizeIndex = PenSizeIndex = {}));
var Pen3DSize;
(function (Pen3DSize) {
    Pen3DSize[Pen3DSize["Small"] = 3] = "Small";
    Pen3DSize[Pen3DSize["Medium"] = 2] = "Medium";
    Pen3DSize[Pen3DSize["Large"] = 1] = "Large";
    Pen3DSize[Pen3DSize["XLarge"] = 0] = "XLarge";
})(Pen3DSize || (exports.Pen3DSize = Pen3DSize = {}));
var UIRestrictableElement;
(function (UIRestrictableElement) {
    UIRestrictableElement[UIRestrictableElement["MainMenuHubButton"] = 0] = "MainMenuHubButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuSearchButton"] = 1] = "MainMenuSearchButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuToolsButton"] = 2] = "MainMenuToolsButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuToolsPenButton"] = 3] = "MainMenuToolsPenButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuToolsLabelsButton"] = 4] = "MainMenuToolsLabelsButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuToolsTextboxButton"] = 5] = "MainMenuToolsTextboxButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuToolsSketchButton"] = 6] = "MainMenuToolsSketchButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuToolsCutButton"] = 7] = "MainMenuToolsCutButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuToolsFractureButton"] = 8] = "MainMenuToolsFractureButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuToolsGrowthButton"] = 9] = "MainMenuToolsGrowthButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuToolsSpursButton"] = 10] = "MainMenuToolsSpursButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuToolsPainButton"] = 11] = "MainMenuToolsPainButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuToolsImportButton"] = 12] = "MainMenuToolsImportButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuLibraryButton"] = 13] = "MainMenuLibraryButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuStoreButton"] = 14] = "MainMenuStoreButton";
    UIRestrictableElement[UIRestrictableElement["MainMenuSettingsButton"] = 15] = "MainMenuSettingsButton";
    UIRestrictableElement[UIRestrictableElement["ActionMenuExportImageButton"] = 16] = "ActionMenuExportImageButton";
    UIRestrictableElement[UIRestrictableElement["ActionMenuSaveScreenButton"] = 17] = "ActionMenuSaveScreenButton";
    UIRestrictableElement[UIRestrictableElement["ActionMenuSaveRecordingButton"] = 18] = "ActionMenuSaveRecordingButton";
    UIRestrictableElement[UIRestrictableElement["ActionMenuARButton"] = 19] = "ActionMenuARButton";
    UIRestrictableElement[UIRestrictableElement["ActionMenuTipsButton"] = 20] = "ActionMenuTipsButton";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuGrossFullBody"] = 21] = "ModelsMenuGrossFullBody";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuGrossHeadAndNeck"] = 22] = "ModelsMenuGrossHeadAndNeck";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuGrossUpperLimbRight"] = 23] = "ModelsMenuGrossUpperLimbRight";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuGrossUpperLimbLeft"] = 24] = "ModelsMenuGrossUpperLimbLeft";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuGrossThorax"] = 25] = "ModelsMenuGrossThorax";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuGrossAbdomen"] = 26] = "ModelsMenuGrossAbdomen";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuGrossPelvis"] = 27] = "ModelsMenuGrossPelvis";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuGrossBack"] = 28] = "ModelsMenuGrossBack";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuGrossLowerLimbRight"] = 29] = "ModelsMenuGrossLowerLimbRight";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuGrossLowerLimbLeft"] = 30] = "ModelsMenuGrossLowerLimbLeft";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuGrossFemalePelvis"] = 31] = "ModelsMenuGrossFemalePelvis";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuGrossFemaleThorax"] = 32] = "ModelsMenuGrossFemaleThorax";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedEye"] = 33] = "ModelsMenuDetailedEye";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedBlood"] = 34] = "ModelsMenuDetailedBlood";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedBloodVessels"] = 35] = "ModelsMenuDetailedBloodVessels";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedBoneCrossSection"] = 36] = "ModelsMenuDetailedBoneCrossSection";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedBronchialTree"] = 37] = "ModelsMenuDetailedBronchialTree";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedCochlea"] = 38] = "ModelsMenuDetailedCochlea";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedKidneyLobe"] = 39] = "ModelsMenuDetailedKidneyLobe";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedLymphNode"] = 40] = "ModelsMenuDetailedLymphNode";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedOlfactoryOrgan"] = 41] = "ModelsMenuDetailedOlfactoryOrgan";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedPeripheralNerve"] = 42] = "ModelsMenuDetailedPeripheralNerve";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedRetinalLayers"] = 43] = "ModelsMenuDetailedRetinalLayers";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedScalpAndMeninges"] = 44] = "ModelsMenuDetailedScalpAndMeninges";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedSkeletalMuscle"] = 45] = "ModelsMenuDetailedSkeletalMuscle";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedSkeletalMuscleFiber"] = 46] = "ModelsMenuDetailedSkeletalMuscleFiber";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedSkin"] = 47] = "ModelsMenuDetailedSkin";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedSuprarenalGland"] = 48] = "ModelsMenuDetailedSuprarenalGland";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedTendon"] = 49] = "ModelsMenuDetailedTendon";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedTongue"] = 50] = "ModelsMenuDetailedTongue";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedTooth"] = 51] = "ModelsMenuDetailedTooth";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedPhotoreceptorCells"] = 52] = "ModelsMenuDetailedPhotoreceptorCells";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedSecondaryOocyte"] = 53] = "ModelsMenuDetailedSecondaryOocyte";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedSperm"] = 54] = "ModelsMenuDetailedSperm";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedNervousTissueCells"] = 55] = "ModelsMenuDetailedNervousTissueCells";
    UIRestrictableElement[UIRestrictableElement["ModelsMenuDetailedSynapse"] = 56] = "ModelsMenuDetailedSynapse";
    UIRestrictableElement[UIRestrictableElement["LibraryCoursesTabSortButton"] = 57] = "LibraryCoursesTabSortButton";
    UIRestrictableElement[UIRestrictableElement["LibraryCoursesTabFilterButton"] = 58] = "LibraryCoursesTabFilterButton";
    UIRestrictableElement[UIRestrictableElement["LibraryCurriculumManagerButton"] = 59] = "LibraryCurriculumManagerButton";
    UIRestrictableElement[UIRestrictableElement["LibraryAtlasSearchButton"] = 60] = "LibraryAtlasSearchButton";
    UIRestrictableElement[UIRestrictableElement["LibraryAtlasTabSortButton"] = 61] = "LibraryAtlasTabSortButton";
    UIRestrictableElement[UIRestrictableElement["LibraryAtlasTabFilterButton"] = 62] = "LibraryAtlasTabFilterButton";
    UIRestrictableElement[UIRestrictableElement["LibraryAtlasCreateQuizButton"] = 63] = "LibraryAtlasCreateQuizButton";
    UIRestrictableElement[UIRestrictableElement["LibraryAtlasCreateQuestionButton"] = 64] = "LibraryAtlasCreateQuestionButton";
    UIRestrictableElement[UIRestrictableElement["LibraryAtlasItemsFound"] = 65] = "LibraryAtlasItemsFound";
    UIRestrictableElement[UIRestrictableElement["LibraryVideoUploadButton"] = 66] = "LibraryVideoUploadButton";
    UIRestrictableElement[UIRestrictableElement["SettingsTabMyAccount"] = 67] = "SettingsTabMyAccount";
    UIRestrictableElement[UIRestrictableElement["SettingsTabNotifications"] = 68] = "SettingsTabNotifications";
    UIRestrictableElement[UIRestrictableElement["SettingsTabPreferences"] = 69] = "SettingsTabPreferences";
    UIRestrictableElement[UIRestrictableElement["SettingsTabSharing"] = 70] = "SettingsTabSharing";
    UIRestrictableElement[UIRestrictableElement["SettingsTabAbout"] = 71] = "SettingsTabAbout";
    UIRestrictableElement[UIRestrictableElement["SettingsTabTips"] = 72] = "SettingsTabTips";
    UIRestrictableElement[UIRestrictableElement["SettingsMyAccountRedeemCode"] = 73] = "SettingsMyAccountRedeemCode";
    UIRestrictableElement[UIRestrictableElement["SettingsMyAccountAuthorBiography"] = 74] = "SettingsMyAccountAuthorBiography";
    UIRestrictableElement[UIRestrictableElement["SettingsSharingManageGroupMembers"] = 75] = "SettingsSharingManageGroupMembers";
    UIRestrictableElement[UIRestrictableElement["SettingsSharingGoToDashboardButton"] = 76] = "SettingsSharingGoToDashboardButton";
    UIRestrictableElement[UIRestrictableElement["SettingsActiveFeatureTabsButton"] = 77] = "SettingsActiveFeatureTabsButton";
    UIRestrictableElement[UIRestrictableElement["SettingsActiveFeatureToolsButton"] = 78] = "SettingsActiveFeatureToolsButton";
    UIRestrictableElement[UIRestrictableElement["SettingsActiveFeatureSaveScreenButton"] = 79] = "SettingsActiveFeatureSaveScreenButton";
    UIRestrictableElement[UIRestrictableElement["SettingsActiveFeatureTipsButton"] = 80] = "SettingsActiveFeatureTipsButton";
    UIRestrictableElement[UIRestrictableElement["SettingsActiveFeatureARModeButton"] = 81] = "SettingsActiveFeatureARModeButton";
    UIRestrictableElement[UIRestrictableElement["SettingsActiveFeatureExportImageButton"] = 82] = "SettingsActiveFeatureExportImageButton";
    UIRestrictableElement[UIRestrictableElement["Tabs"] = 83] = "Tabs";
})(UIRestrictableElement || (exports.UIRestrictableElement = UIRestrictableElement = {}));
var UIAccessModifier;
(function (UIAccessModifier) {
    UIAccessModifier[UIAccessModifier["Restricted"] = 0] = "Restricted";
    UIAccessModifier[UIAccessModifier["Regular"] = 1] = "Regular";
})(UIAccessModifier || (exports.UIAccessModifier = UIAccessModifier = {}));
var SnackbarType;
(function (SnackbarType) {
    SnackbarType[SnackbarType["AutoSyncSwitchedOff"] = 0] = "AutoSyncSwitchedOff";
    SnackbarType[SnackbarType["ExitToAnnotate"] = 1] = "ExitToAnnotate";
    SnackbarType[SnackbarType["GeoBlock"] = 2] = "GeoBlock";
    SnackbarType[SnackbarType["ItemDownload"] = 3] = "ItemDownload";
    SnackbarType[SnackbarType["LectureBeingCopied"] = 4] = "LectureBeingCopied";
    SnackbarType[SnackbarType["LectureHasBeenCopied"] = 5] = "LectureHasBeenCopied";
    SnackbarType[SnackbarType["LectureHasBeenDownloaded"] = 6] = "LectureHasBeenDownloaded";
    SnackbarType[SnackbarType["LimitGroupLabels"] = 7] = "LimitGroupLabels";
    SnackbarType[SnackbarType["LimitLabels"] = 8] = "LimitLabels";
    SnackbarType[SnackbarType["LimitStickies"] = 9] = "LimitStickies";
    SnackbarType[SnackbarType["LimitStructures"] = 10] = "LimitStructures";
    SnackbarType[SnackbarType["MemoryLimitationsCourse"] = 11] = "MemoryLimitationsCourse";
    SnackbarType[SnackbarType["Offline"] = 12] = "Offline";
    SnackbarType[SnackbarType["OfflineContentType"] = 13] = "OfflineContentType";
    SnackbarType[SnackbarType["OfflineItemSync"] = 14] = "OfflineItemSync";
    SnackbarType[SnackbarType["OfflineLectures"] = 15] = "OfflineLectures";
    SnackbarType[SnackbarType["OfflineQuiz"] = 16] = "OfflineQuiz";
    SnackbarType[SnackbarType["OfflineSearch"] = 17] = "OfflineSearch";
    SnackbarType[SnackbarType["OfflineVideos"] = 18] = "OfflineVideos";
    SnackbarType[SnackbarType["QuizEditCantSetThumb"] = 19] = "QuizEditCantSetThumb";
    SnackbarType[SnackbarType["QuizEditMinimumQuestions"] = 20] = "QuizEditMinimumQuestions";
    SnackbarType[SnackbarType["RecordingSaved"] = 21] = "RecordingSaved";
    SnackbarType[SnackbarType["Restore"] = 22] = "Restore";
    SnackbarType[SnackbarType["ShowHiddenStructures"] = 23] = "ShowHiddenStructures";
    SnackbarType[SnackbarType["TrialExpires"] = 24] = "TrialExpires";
    SnackbarType[SnackbarType["UserDoesntMatch"] = 25] = "UserDoesntMatch";
    SnackbarType[SnackbarType["VideoExportCancel"] = 26] = "VideoExportCancel";
    SnackbarType[SnackbarType["DrawCutLine"] = 27] = "DrawCutLine";
    SnackbarType[SnackbarType["OfflineAudio"] = 28] = "OfflineAudio";
    SnackbarType[SnackbarType["OfflineCrossSections"] = 29] = "OfflineCrossSections";
})(SnackbarType || (exports.SnackbarType = SnackbarType = {}));
var CutModelAction;
(function (CutModelAction) {
    CutModelAction[CutModelAction["Move"] = 0] = "Move";
    CutModelAction[CutModelAction["Cut"] = 1] = "Cut";
    CutModelAction[CutModelAction["Cancel"] = 2] = "Cancel";
})(CutModelAction || (exports.CutModelAction = CutModelAction = {}));
var AppRegion;
(function (AppRegion) {
    AppRegion[AppRegion["Unknown"] = -1] = "Unknown";
    AppRegion[AppRegion["ROW"] = 0] = "ROW";
    AppRegion[AppRegion["China"] = 1] = "China";
})(AppRegion || (exports.AppRegion = AppRegion = {}));
var ModelsPanelTabType;
(function (ModelsPanelTabType) {
    ModelsPanelTabType[ModelsPanelTabType["Female"] = 0] = "Female";
    ModelsPanelTabType[ModelsPanelTabType["Male"] = 1] = "Male";
    ModelsPanelTabType[ModelsPanelTabType["Detailed"] = 2] = "Detailed";
    ModelsPanelTabType[ModelsPanelTabType["Pinned"] = 3] = "Pinned";
})(ModelsPanelTabType || (exports.ModelsPanelTabType = ModelsPanelTabType = {}));
var ODRModelStatus;
(function (ODRModelStatus) {
    ODRModelStatus[ODRModelStatus["Unknown"] = 0] = "Unknown";
    ODRModelStatus[ODRModelStatus["Downloading"] = 1] = "Downloading";
    ODRModelStatus[ODRModelStatus["Paused"] = 2] = "Paused";
    ODRModelStatus[ODRModelStatus["Cached"] = 3] = "Cached";
    ODRModelStatus[ODRModelStatus["Failed"] = 4] = "Failed";
    ODRModelStatus[ODRModelStatus["Offloaded"] = 5] = "Offloaded";
})(ODRModelStatus || (exports.ODRModelStatus = ODRModelStatus = {}));
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus[NotificationStatus["Unread"] = 0] = "Unread";
    NotificationStatus[NotificationStatus["Read"] = 1] = "Read";
})(NotificationStatus || (exports.NotificationStatus = NotificationStatus = {}));
var SearchContentType;
(function (SearchContentType) {
    SearchContentType[SearchContentType["BodyRegions"] = 0] = "BodyRegions";
    SearchContentType[SearchContentType["Clusters"] = 1] = "Clusters";
    SearchContentType[SearchContentType["Compositions"] = 2] = "Compositions";
    SearchContentType[SearchContentType["Medias"] = 3] = "Medias";
    SearchContentType[SearchContentType["Shapes"] = 4] = "Shapes";
    SearchContentType[SearchContentType["Spots"] = 5] = "Spots";
    SearchContentType[SearchContentType["Structures"] = 6] = "Structures";
})(SearchContentType || (exports.SearchContentType = SearchContentType = {}));
